module.exports = __webpack_public_path__ + "images/frontpage_mobile@1x.jpg?f1d56899";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_mobile@1x.jpg
// module id = 654
// module chunks = 7